export const PROFILE_FORM_INIT_ACTION = "PROFILE_FORM_INIT"
export const AUTHENTICATION_FORM_INIT_ACTION = "AUTHENTICATION_FORM_INIT"
